import './styles.css';
import { CONFIG } from './config.js';
import { completeAuthorization, ConnectError, isCallback, startAuthorization } from './oauth.js';

const $ = (selector) => document.querySelector(selector);

function show(view) {
  for (const section of document.querySelectorAll('[data-view]')) {
    section.hidden = section.dataset.view !== view;
  }
}

function showError(message) {
  $('[data-error-message]').textContent = message;
  show('error');
}

async function connect({ signUp = false } = {}) {
  const pageParams = new URLSearchParams(window.location.search);
  try {
    window.location.assign(await startAuthorization(CONFIG, localStorage, { pageParams, signUp }));
  } catch {
    showError('Your browser blocked the connection (local storage or secure crypto is unavailable). Try another browser.');
  }
}

function showToken(token) {
  const input = $('#token');
  input.value = token;

  const toggle = $('[data-action="toggle"]');
  const setVisible = (visible) => {
    input.type = visible ? 'text' : 'password';
    const label = visible ? 'Hide token' : 'Show token';
    toggle.setAttribute('aria-label', label);
    toggle.setAttribute('aria-pressed', String(visible));
    toggle.title = label;
  };

  toggle.addEventListener('click', () => setVisible(input.type === 'password'));

  $('[data-action="copy"]').addEventListener('click', async () => {
    const status = $('[data-copy-status]');
    try {
      await navigator.clipboard.writeText(token);
      status.textContent = 'Copied to clipboard.';
    } catch {
      setVisible(true);
      input.select();
      status.textContent = 'Press Ctrl+C (⌘C on Mac) to copy.';
    }
  });

  show('success');
}

async function handleCallback(params) {
  show('working');
  window.history.replaceState(null, '', window.location.pathname);
  try {
    showToken(await completeAuthorization(CONFIG, params, localStorage));
  } catch (error) {
    showError(error instanceof ConnectError ? error.message : 'Something went wrong. Please try again.');
  }
}

$('[data-link="actor"]').href = CONFIG.actorUrl;
$('[data-link="applications"]').href = CONFIG.applicationsUrl;
for (const button of document.querySelectorAll('[data-action="connect"]')) {
  button.addEventListener('click', () => connect());
}
$('[data-action="signup"]').addEventListener('click', () => connect({ signUp: true }));

const params = new URLSearchParams(window.location.search);
if (isCallback(params)) {
  handleCallback(params);
} else {
  show('start');
}
